<template>
  <div class="gift-setting-page">
    <el-form ref="form" :model="form" label-width="150px">
      <div class="setting-card">
        <h3 class="page-title">送礼设置</h3>

        <el-form-item label="赠礼指南配置" class="setting-item">
          <el-button class="outline-btn" @click="handleTemplateSetting">模板设置</el-button>
          <span class="status-text">{{ guideConfigured ? '已配置' : '未配置' }}</span>
          <div class="frm-tips">配置小程序「赠礼指南」页面的可视化样式，支持热区图、轮播等组件。</div>
        </el-form-item>

        <el-form-item label="赠礼定制服务弹窗" class="setting-item">
          <div class="image-setting">
            <div v-if="form.custom_service_popup_image" class="preview-wrap">
              <img :src="previewImage" class="service-preview">
              <i class="el-icon-circle-close close-icon" @click.stop="removeServiceImage" />
            </div>
            <div v-else class="empty-preview">
              <i class="iconfont icon-camera" />
            </div>
            <el-button class="change-btn" @click="openImagePicker">更换图片</el-button>
          </div>
          <div class="frm-tips">建议尺寸 600x800px，支持 JPG / PNG / WebP，单张不超过 2MB，用户进入定制服务时展示此弹窗。</div>
        </el-form-item>

        <el-form-item label="电子贺卡配置" class="setting-item no-border">
          <el-button class="outline-btn" @click="goBlessingList">祝福语维护列表</el-button>
          <div class="frm-tips">管理电子贺卡的分类、封面、祝福语内容及分享设置。</div>
        </el-form-item>

        <div class="footer-actions">
          <el-button @click="handleCancel">取消</el-button>
          <el-button type="primary" :loading="saving" @click="handleSave">保存</el-button>
        </div>
      </div>
    </el-form>

    <el-dialog
      :visible.sync="decorateDialog"
      width="92vw"
      top="5vh"
      append-to-body
      class="gift-guide-dialog"
      @close="handleDecorateClose"
    >
      <div slot="title" class="gift-guide-dialog-title">
        <span>赠礼指南模板设置</span>
        <el-button type="primary" size="small" @click="handleDecorateConfirm">确认</el-button>
      </div>
      <Decorate
        v-if="decorateDialog"
        ref="decorateRef"
        mode="dialog"
        scene="1005"
        title=""
        :value="decorateValue"
        @change="handleDecorateChange"
        @close="decorateDialog = false"
      />
    </el-dialog>

    <imgPicker
      :dialog-visible="imgDialog"
      :sc-status="isGetImage"
      @chooseImg="pickImg"
      @closeImgDialog="closeImgDialog"
    />
  </div>
</template>

<script>
import imgPicker from '@/components/imageselect'
import Decorate from '@/view/decorate/index'
import { getGiftordersetting, postGiftordersetting } from '@/api/giving'

export default {
  components: {
    imgPicker,
    Decorate
  },
  data() {
    return {
      form: {
        custom_service_popup_image: '',
        gift_guide_content: []
      },
      initialForm: {
        custom_service_popup_image: '',
        gift_guide_content: []
      },
      decorateValue: [],
      decorateDialog: false,
      imgDialog: false,
      isGetImage: false,
      saving: false
    }
  },
  computed: {
    previewImage() {
      if (!this.form.custom_service_popup_image) return ''
      if (/^https?:\/\//.test(this.form.custom_service_popup_image)) return this.form.custom_service_popup_image
      return this.wximageurl + this.form.custom_service_popup_image
    },
    guideConfigured() {
      return this.parseGuideContent(this.form.gift_guide_content).length > 0
    }
  },
  mounted() {
    this.getSetting()
  },
  methods: {
    async getSetting() {
      const { data } = await getGiftordersetting()
      const info = data && data.data ? data.data : {}
      this.form = {
        ...this.form,
        ...info,
        custom_service_popup_image: info.custom_service_popup_image || '',
        gift_guide_content: this.parseGuideContent(info.gift_guide_content)
      }
      this.initialForm = JSON.parse(JSON.stringify(this.form))
    },
    parseGuideContent(content) {
      if (!content) return []
      if (Array.isArray(content)) return content
      if (typeof content === 'object') {
        return content.list || content.content || []
      }
      try {
        const data = JSON.parse(content)
        if (Array.isArray(data)) return data
        return data.list || data.content || []
      } catch (error) {
        return []
      }
    },
    normalizeGuideContent(content) {
      return this.parseGuideContent(content).map((item) => {
        const result = JSON.parse(JSON.stringify(item))
        const params = result.params || result
        if (params.name === 'imgHotzone') {
          params.config = params.config || {}
          if (!Array.isArray(params.config.channel)) {
            params.config.channel = []
          }
        }
        return result
      })
    },

    handleTemplateSetting() {
      this.decorateValue = JSON.parse(JSON.stringify(this.normalizeGuideContent(this.form.gift_guide_content)))
      this.decorateDialog = true
    },
    handleDecorateChange(data) {
      this.decorateValue = this.normalizeGuideContent(data)
      this.form.gift_guide_content = this.decorateValue
      this.decorateDialog = false
      this.$message.success('模板配置已更新，请点击保存生效')
    },
    handleDecorateConfirm() {
      if (this.$refs.decorateRef) {
        this.$refs.decorateRef.onSaveTemplate()
      } else {
        this.decorateDialog = false
      }
    },
    handleDecorateClose() {
      this.decorateValue = []
    },
    openImagePicker() {
      this.imgDialog = true
      this.isGetImage = true
    },
    pickImg(data) {
      this.form.custom_service_popup_image = data.url
      this.closeImgDialog()
    },
    closeImgDialog() {
      this.imgDialog = false
      this.isGetImage = false
    },
    removeServiceImage() {
      this.form.custom_service_popup_image = ''
    },
    goBlessingList() {
      this.$router.push({ path: this.matchInternalRoute('marketing/giftingorder/giftingorderblessing') })
    },
    handleCancel() {
      this.form = JSON.parse(JSON.stringify(this.initialForm))
    },
    async handleSave() {
      this.saving = true
      try {
        const giftGuideContent = this.normalizeGuideContent(this.form.gift_guide_content)
        await postGiftordersetting({
          custom_service_popup_image: this.form.custom_service_popup_image,
          gift_guide_content: JSON.stringify(giftGuideContent)
        })
        this.form.gift_guide_content = giftGuideContent
        this.initialForm = JSON.parse(JSON.stringify(this.form))
        this.$message.success('保存成功')
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style scoped type="text/css" lang="scss">
.gift-setting-page {
  min-height: 100%;
  padding: 20px;
  background: #f5f7fa;
}

.setting-card {
  min-height: 560px;
  padding: 28px 32px;
  background: #fff;
}

.page-title {
  margin: 0 0 34px;
  color: #333;
  font-size: 16px;
  font-weight: 600;
}

.setting-item {
  margin-bottom: 0;
  padding: 0 0 26px;
  border-bottom: 1px solid #ebeef5;

  ::v-deep .el-form-item__label {
    color: #333;
    font-weight: 600;
    text-align: left;
  }

  ::v-deep .el-form-item__content {
    line-height: normal;
  }

  & + .setting-item {
    padding-top: 26px;
  }

  &.no-border {
    border-bottom: none;
  }
}

.outline-btn {
  min-width: 92px;
  color: #2d8cf0;
  border-color: #9acaf5;
}

.status-text {
  margin-left: 14px;
  color: #666;
}

.frm-tips {
  margin-top: 10px;
  color: #999;
  font-size: 13px;
  line-height: 20px;
}

.image-setting {
  position: relative;
  width: 122px;
  height: 122px;
}

.preview-wrap,
.empty-preview {
  width: 122px;
  height: 122px;
  overflow: hidden;
  background: #f4f4f5;
  border-radius: 2px;
}

.service-preview {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.empty-preview {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c0c4cc;
}

.icon-camera {
  font-size: 28px;
}

.close-icon {
  position: absolute;
  top: -8px;
  right: -8px;
  color: #666;
  font-size: 18px;
  cursor: pointer;
}

.change-btn {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 122px;
  color: #fff;
  background: rgba(0, 0, 0, .55);
  border: none;
  border-radius: 0;
}

.footer-actions {
  margin-top: 96px;
  text-align: center;

  .el-button {
    width: 90px;
    margin: 0 4px;
  }
}

</style>

<style lang="scss">
.gift-guide-dialog {
  .el-dialog {
    max-width: 1680px;
  }

  .decorate-hd {
    height: 0;
    min-height: 0;
    padding: 0;
    overflow: hidden;
    border-bottom: none;
  }

  .el-dialog__body {
    height: 78vh;
    padding: 0;
    overflow: hidden;
  }

  .page-decorate-index {
    height: 78vh;
    position: relative;
  }

  .decorate-bd {
    height: 78vh;
  }

  .left-container {
    height: 78vh;
  }

  .center-container {
    top: 0;
    bottom: 0;
  }

  .right-container {
    top: 0;
    bottom: 0;
  }

  .center-container .weapp-template {
    margin-top: 24px;
  }
}

.gift-guide-dialog-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 36px;
}
</style>
